import { IBackend } from '@/api/BackendApi';
import { TreeBackendApi } from '@/types/tree/props';
import { toProjectUIModel } from '@/lib/models/projectUIModel';

// Helper to safely parse numeric IDs with validation
const parseNumericId = (id: string, nodeType: string): number => {
  const parsed = parseInt(id, 10);
  if (isNaN(parsed)) {
    throw new Error(`Invalid numeric ID for ${nodeType}: "${id}"`);
  }
  return parsed;
};

// Create a backend API adapter

export const createTreeStoreBackendApi = (backend: IBackend): TreeBackendApi => ({
  getNode: async (type, id) => {
    switch (type) {
      case 'sample':
      case 'sampleAggregate':
      case 'sampleInPackage':
        return backend.sample.get(id);
      case 'sampleSnapshot':
        // Numeric snapshot PK — live /samples/{id} 404s for unpublished copies and is the wrong auth path.
        return backend.sampleSnapshot.get(parseNumericId(id, 'sampleSnapshot'));
      case 'sampleActivity':
      case 'sampleActivityAggregate':
      case 'sampleActivityInPackage':
      case 'sampleActivitySnapshot':
        return backend.sampleActivity.get(parseNumericId(id, 'sampleActivity'));
      case 'project':
      case 'projectInData':
        return toProjectUIModel(await backend.project.get(id));
      case 'projectActivity':
        return backend.projectActivity.get(parseNumericId(id, 'projectActivity'));
      case 'publication':
      case 'publicationInData':
        return backend.publication.getByIdOrDoi(id);
      case 'dataPackage':
        return backend.data.get(id);
      case 'simulationDataset':
        return backend.data.get(id);
      case 'communication':
        return backend.communication.get(parseNumericId(id, 'communication'));
      case 'theoryActivity':
      case 'theoryActivityInPackage':
        return backend.theoryActivity.get(parseNumericId(id, 'theoryActivity'));
      case 'shipping':
        return backend.shipping.read(parseNumericId(id, 'shipping'));
      default:
        throw new Error(`Unsupported node type: ${type}`);
    }
  },
});
